import { Component, OnDestroy } from '@angular/core';
import { CurrentUserService } from '@core/services';
import { UserGroupService } from '@core/services/user-group.service';
import { environment } from '@environments/environment';
import { maximumNumberOfCartOrdersDisplayed } from '@layout/core/constants';
import { TranslateModule } from '@ngx-translate/core';
import { EllipsisTooltipComponent } from '@shared/components';
import { UserRoleEnum } from '@shared/enums';
import { CurrentUser } from '@shared/interfaces';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { Subscription } from 'rxjs';
import { MenuCartOrdersComponent } from '../menu-cart-orders/menu-cart-orders.component';
import { MenuCartOrdersService } from '../menu-cart-orders/menu-cart-orders.service';
import { MenuProfileComponent } from '../menu-profile/menu-profile.component';
import { MenuServicesComponent } from '../menu-services/menu-services.component';
import { MenuSupportComponent } from '../menu-support/menu-support.component';
import { UserAvatarComponent } from '../user-avatar.component';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss', './toolbar-mobile.component.scss'],
    standalone: true,
    imports: [
        ButtonModule,
        BadgeModule,
        UserAvatarComponent,
        OverlayPanelModule,
        MenuServicesComponent,
        MenuSupportComponent,
        MenuProfileComponent,
        MenuCartOrdersComponent,
        TranslateModule,
        EllipsisTooltipComponent,
    ],
})
export class ToolbarComponent implements OnDestroy {
    private readonly subscriptions = new Subscription();

    readonly ordersUrl = environment.ordersUrl;
    readonly quickorderMessagesUrl = environment.quickorderMessagesUrl;
    readonly roles = UserRoleEnum;

    currentUser: CurrentUser | null = null;
    isSwitchGroupDisplayed = false;
    cartOrdersNumber: string = '0';
    window = window;
    hideMenuCart: boolean = false;

    constructor(
        private currentUserService: CurrentUserService,
        private menuCartOrdersService: MenuCartOrdersService,
        private userGroupService: UserGroupService
    ) {
        this.subscriptions.add(
            this.currentUserService.currentUser$.subscribe(user => {
                this.currentUser = user;
            })
        );
        this.subscriptions.add(
            this.menuCartOrdersService.menuCartOrders$.subscribe(menuCartOrders => {
                if (menuCartOrders) {
                    this.cartOrdersNumber =
                        menuCartOrders.length > maximumNumberOfCartOrdersDisplayed
                            ? `${maximumNumberOfCartOrdersDisplayed}+`
                            : String(menuCartOrders.length);
                } else {
                    this.cartOrdersNumber = '0';
                }
            })
        );

        this.subscriptions.add(this.userGroupService.groupsError$.subscribe(() => (this.hideMenuCart = true)));

        this.subscriptions.add(
            this.userGroupService.groups$.subscribe(groups => {
                this.hideMenuCart = !groups?.length;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
